import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../OrderOptions.scss";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../assets/i18n";
import formatCnpj from '../../../helpers/formatCnpj';

function OrderOptionsProviderTab(props) {
    const { fornecedor } = props;
    const lang = useSelector(state => state.language.name)
    const pageMessages = messages[lang].orderOptions.fornecedor

    return (
        <Container>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.id}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.id}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2.5} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cnpj}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.cnpj ? formatCnpj(fornecedor.cnpj) : ''}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.nome}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.nome}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.email}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.email}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cidade}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.cidade}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={1} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.uf}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.uf}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.exigirDeclProdutor}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.exigirDeclProdutor ? 'Sim' : 'Não'}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={1} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.ediPoInd}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={fornecedor.ediPoInd}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
        </Container>
    );
}

OrderOptionsProviderTab.propTypes = {
    fornecedor: PropTypes.object
};

const mapStateToProps = state => ({
    lang: state.language
});

export default connect(mapStateToProps)(OrderOptionsProviderTab);